import React from 'react';
import { createIcon } from './create-icon';
import './icon-unsupported.scss';

export const IconUnsupported = createIcon(<div className="icon-unsupported" />);
